<template>
  <div>
    <div v-if="TherapyStatus !=='playing'"
         class="pending-cover blur-bg">
      <div class="left-cover">
        <h2>{{text}}</h2>
      </div>
      <div class="right-cover">

        <h2>{{text}}</h2>
      </div>
    </div>
    <div id="loading">
      <img id="loading-resource"
           src="../../assets/images/loading.gif"
           alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  props: {},
  computed: {
    ...mapState({
      TherapyStatus: state => state.therapy._THERAPY_STATUS_,
    }),
    text() {
      switch (this.TherapyStatus) {
        case 'ending':
          return '训练结束'
        case 'ready':
          return '设置中'
          break

        default:
          '等待接入'
          break
      }
    },
  },
}
</script>


<style lang="scss">
.pending-cover {
  margin: auto;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 101;
  display: flex;
  .left-cover,
  .right-cover {
    width: 50%;
    margin: auto;
    display: inline-block;
    text-align: center;
  }
}
</style>

